import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { GRID_BREAKPOINT_MEDIUM } from 'HubStyleTokens/sizes';
import getLang from 'I18n/utils/getLang';
import UIApplication from 'UIComponents/app/UIApplication';
import UIBox from 'UIComponents/layout/UIBox'; // @ts-expect-error MarketingNavHeader not typed yet

import MarketingNavHeader from 'ecosystem-marketplace-core/components/nav/MarketingNavHeader'; // @ts-expect-error MarketingNavFooter not typed yet

import MarketingNavFooter from 'ecosystem-marketplace-core/components/nav/MarketingNavFooter';
import { useWindowDimensionsContext } from 'ecosystem-marketplace-core/hooks/useWindowDimensionsContext';
import { getAppShortUrl, getCmsHubPricingUrl, getFullPublicUrl } from 'marketplace-assets-base/utils/urls';
const GRID_BREAKPOINT_MEDIUM_INT = parseInt(GRID_BREAKPOINT_MEDIUM, 10);
const languagesContent = {
  en: ['English'],
  jp: ['日本語'],
  de: ['Deutsch'],
  es: ['Español'],
  pt: ['Português'],
  fr: ['Français']
};
const StyledUIApplication = styled(UIApplication).withConfig({
  displayName: "AppContainer__StyledUIApplication",
  componentId: "sc-1iz9e71-0"
})(["display:flex;flex-direction:column;"]);
const StyledMainContent = styled(props => /*#__PURE__*/_jsx(UIBox, Object.assign({}, props, {
  grow: 1,
  shrink: 1
}))).withConfig({
  displayName: "AppContainer__StyledMainContent",
  componentId: "sc-1iz9e71-1"
})(["min-height:100vh;"]);

const AppContainer = ({
  children,
  name
}) => {
  const lang = getLang();
  const location = useLocation();
  const hydratedLanguagesContent = useMemo(() => {
    return Object.keys(languagesContent).reduce((final, langKey) => {
      const [langName] = languagesContent[langKey];
      return Object.assign({}, final, {
        [langKey]: [langName, getFullPublicUrl(langKey), '']
      });
    }, {});
  }, []);
  const headerContentBlob = useMemo(() => {
    const navCtaUrl = getCmsHubPricingUrl();
    return {
      upperNavContent: {
        homeUrl: getFullPublicUrl(lang),
        loginUrl: `${getAppShortUrl()}${location.pathname}`,
        regionalDropdownContent: {
          languagesContent: hydratedLanguagesContent
        }
      },
      mobileNavContent: {
        languagesContent: hydratedLanguagesContent
      },
      navCta: {
        navCtaUrl
      }
    };
  }, [hydratedLanguagesContent, lang, location]);
  const {
    width: windowWidth
  } = useWindowDimensionsContext();
  const headerVariation = windowWidth < GRID_BREAKPOINT_MEDIUM_INT ? 'default' : 'marketplace';
  return /*#__PURE__*/_jsxs(StyledUIApplication, {
    name: name,
    children: [/*#__PURE__*/_jsx(MarketingNavHeader, {
      contentBlob: headerContentBlob,
      enableConvertFlag: true,
      lang: lang,
      variation: headerVariation
    }), /*#__PURE__*/_jsx(StyledMainContent, {
      children: children
    }), /*#__PURE__*/_jsx(MarketingNavFooter, {
      lang: lang
    })]
  });
};

export default AppContainer;